import React from 'react';

function SingleCategory(){

	return <div>
		<h1>Fetching Page...</h1>
	</div>

}
export default SingleCategory

